import { PersonType } from "../types/raynet.type";
import { getCookie } from "../utils/get-cookie";
import Alert from "./Alert";
import { arrayMinMax, formatNumber, handlePhoneCodeChange, isEmailValid, populateSelectBox } from "./Utils";
import * as Sentry from "@sentry/react";
import FormValidationLogger from "../utils/FormValidationLogger";
class CarDetail {
    constructor() {
        this.TAX_VALUE = 1.21;
        this.car = null;
        this.selectCompany = null;
        this.submitButton = null;
        this.orderForm = null;
        this.orderFormButton = null;
        this.monthRange = null;
        this.kmRange = null;
        this.jsMonth = null;
        this.jsKm = null;
        this.jsFormMonth = null;
        this.jsFormKm = null;
        this.jsFormPrice = null;
        this.jsPrice = null;
        this.jsPriceWithoutTax = null;
        this.emailInput = null;
        this.phoneCodesDropdown = null;
        this.phoneInput = null;
        this.phoneCodeInput = null;
        this.currentMonth = 0;
        this.currentKm = 0;
        this.currentPriceWithoutTax = 0;
        this.currentPrice = 0;
    }
    async priceSelect() {
        this.selectCompany = document.getElementById('js-company-select');
        this.submitButton = document.getElementById('js-submit-button');
        this.orderForm = document.getElementById('js-order-form');
        this.orderFormButton = document.getElementById('js-form-submit');
        this.monthRange = document.getElementById('js-month-range');
        this.kmRange = document.getElementById('js-km-range');
        this.jsMonth = document.getElementById('js-month');
        this.jsKm = document.getElementById('js-km');
        this.jsPrice = document.getElementById('js-price');
        this.jsFormKm = document.getElementById('js-form-km');
        this.jsFormMonth = document.getElementById('js-form-month');
        this.jsFormPrice = document.getElementById('js-form-price');
        this.jsPriceWithoutTax = document.getElementById('js-price-without-tax');
        this.emailInput = document.getElementById('form-email');
        this.phoneCodesDropdown = document.getElementById('js-phone-codes');
        this.phoneInput = document.getElementById('form-phone');
        this.phoneCodeInput = document.getElementById('js-phone-code');
        this.car = window.carData;
        this.setRangeValues(true);
        this.priceListeners();
        this.getUrlParams();
        populateSelectBox(this.phoneCodesDropdown);
        if (this.orderForm) {
            FormValidationLogger.initFormValidationLogging(this.orderForm, "Order form", {
                pageType: 'car_detail',
                carId: this.car?.be_id,
                carTitle: this.car?.title
            });
        }
    }
    getUrlParams() {
        const urlParams = new URLSearchParams(window.location.search);
        const km = urlParams.get('km');
        const dur = urlParams.get('dur');
        if (km) {
            this.currentKm = parseFloat(km);
            this.kmRange?.setAttribute('value', this.currentKm.toString());
        }
        if (dur) {
            this.currentMonth = parseFloat(dur);
            this.monthRange?.setAttribute('value', this.currentMonth.toString());
        }
        this.updatePriceValues();
        this.changeCompany();
    }
    setRangeValues(initDefault = false) {
        if (!this.car) {
            return;
        }
        let durations = this.car.op_leas_calcs.flatMap(calc => calc.mnts);
        let distances = this.car.op_leas_calcs.flatMap(calc => calc.km_y);
        if (!initDefault) {
            durations = this.car.op_leas_calcs.filter(calc => calc.km_y === this.currentKm).flatMap(calc => calc.mnts);
            distances = this.car.op_leas_calcs.filter(calc => calc.mnts === this.currentMonth).flatMap(calc => calc.km_y);
        }
        const { minMonth, minKm } = this.setInputAttributes(durations, distances);
        if (initDefault) {
            this.currentMonth = minMonth;
            this.currentKm = minKm;
        }
        this.updatePriceValues();
    }
    setInputAttributes(durations, distances) {
        const [minMonth, maxMonth] = arrayMinMax(durations);
        const [minKm, maxKm] = arrayMinMax(distances);
        this.monthRange?.setAttribute('step', '12');
        this.monthRange?.setAttribute('value', minMonth.toString());
        this.monthRange?.setAttribute('min', minMonth.toString());
        this.monthRange?.setAttribute('max', maxMonth.toString());
        this.kmRange?.setAttribute('step', '5000');
        this.kmRange?.setAttribute('value', minKm.toString());
        this.kmRange?.setAttribute('min', minKm.toString());
        this.kmRange?.setAttribute('max', maxKm.toString());
        return { minMonth, minKm };
    }
    updatePriceValues() {
        if (this.jsKm &&
            this.jsMonth &&
            this.jsPrice &&
            this.jsPriceWithoutTax &&
            this.jsFormKm &&
            this.jsFormMonth &&
            this.jsFormPrice) {
            this.jsFormKm.innerHTML = this.jsKm.innerHTML = formatNumber(this.currentKm).toString();
            this.jsFormMonth.innerHTML = this.jsMonth.innerHTML = formatNumber(this.currentMonth).toString();
            if (this.car) {
                const calculation = this.car.op_leas_calcs.find(calc => calc.km_y === this.currentKm && calc.mnts === this.currentMonth);
                if (calculation) {
                    this.currentPriceWithoutTax = calculation.prc_no_vat;
                    this.currentPrice = calculation.prc_no_vat * this.TAX_VALUE;
                    this.jsPrice.innerHTML = formatNumber(this.currentPrice);
                    this.jsFormPrice.innerHTML = this.jsPriceWithoutTax.innerHTML = formatNumber(this.currentPriceWithoutTax);
                    this.submitButton?.classList.remove('car-detail-form__button--disabled');
                }
                else {
                    Alert.error('Kalkulace nenalezena');
                    this.jsPrice.innerHTML = '';
                    this.jsFormPrice.innerHTML = '';
                    this.jsPriceWithoutTax.innerHTML = '';
                    this.currentPrice = 0;
                    this.currentPriceWithoutTax = 0;
                    this.submitButton?.classList.add('car-detail-form__button--disabled');
                }
            }
        }
    }
    changeCompany() {
        document.querySelector('.js-hide-ico')?.classList.add('d-none');
        document.querySelector('.js-hide-company')?.classList.add('d-none');
        if (this.selectCompany?.value === '2') {
            document.querySelector('.js-hide-ico')?.classList.remove('d-none');
            document.querySelector('.js-hide-company')?.classList.remove('d-none');
        }
        if (this.selectCompany?.value === '3') {
            document.querySelector('.js-hide-ico')?.classList.remove('d-none');
        }
    }
    priceListeners() {
        this.monthRange?.addEventListener('input', this.changeMonth.bind(this));
        this.kmRange?.addEventListener('input', this.changeKm.bind(this));
        this.submitButton?.addEventListener('click', this.openModal.bind(this));
        this.orderForm?.addEventListener('submit', this.submitForm.bind(this));
        this.emailInput?.addEventListener('input', this.handlerEmailInput.bind(this));
        this.selectCompany?.addEventListener('change', this.changeCompany.bind(this));
        this.phoneCodesDropdown?.addEventListener('change', this.changePhoneCode.bind(this));
        document.querySelector('.order-modal__close')?.addEventListener('click', this.toggleModal.bind(this));
    }
    changePhoneCode() {
        if (!this.phoneInput || !this.phoneCodesDropdown || !this.phoneCodeInput) {
            return;
        }
        handlePhoneCodeChange(this.phoneInput, this.phoneCodeInput, this.phoneCodesDropdown);
    }
    toggleModal() {
        const modal = document.querySelector('.order-modal');
        modal?.classList.toggle('order-modal--open');
    }
    openModal() {
        this.toggleModal();
        const titleElement = document.getElementById('js-form-title');
        if (titleElement && this.car) {
            titleElement.innerHTML = this.car.title;
        }
    }
    handlerEmailInput() {
        this.emailInput?.setCustomValidity('');
    }
    async submitForm(event) {
        event.preventDefault();
        if (!isEmailValid(this.emailInput)) {
            if (this.emailInput) {
                Sentry.withScope(scope => {
                    scope.setLevel('warning');
                    scope.setTag('error_type', 'form_validation');
                    scope.setContext('Form Context', {
                        email: this.emailInput?.value,
                        carId: this.car?.be_id,
                        carTitle: this.car?.title
                    });
                    Sentry.captureMessage('Order form submission blocked by RayNet email validation regexp');
                });
            }
            return;
        }
        this.orderFormButton?.classList.add('btn--preloader');
        const url = document.body.getAttribute('data-api-url');
        const data = this.prepareFormData();
        // this.sendConversion(); // temporarily disabled until ga4
        try {
            await fetch(url, {
                method: "POST",
                mode: 'no-cors',
                body: JSON.stringify(data)
            });
            Alert.success('Formulář byl úspěšně odeslán');
            this.clearForm();
        }
        catch (error) {
            this.logToSentry(error, data);
            Alert.error('Chyba odeslání formuláře');
        }
    }
    sendConversion() {
        const sclick = document.body.getAttribute('data-sclick');
        const price = this.currentPrice;
        const conversionConf = {
            id: sclick,
            value: price,
        };
        if (window && window.rc.conversionHit) {
            window.rc.conversionHit(conversionConf);
        }
        const gtag = window.gtag;
        gtag("event", "generate_lead", {
            currency: "CZK",
            value: price
        });
    }
    clearForm() {
        this.orderFormButton?.classList.remove('btn--preloader');
        this.toggleModal();
    }
    prepareFormData() {
        if (!this.orderForm) {
            return;
        }
        const formData = Object.fromEntries(new FormData(this.orderForm).entries());
        const typeMap = {
            1: PersonType.PRIVATE_PERSON,
            2: PersonType.COMPANY,
            3: PersonType.BUSINESSMAN,
        };
        const type = Number(formData.type);
        const gaCookie = getCookie("_ga");
        return {
            contactSource: 144,
            customFields: {
                /* eslint-disable camelcase */
                ...(gaCookie && { Cokie__ga_082f6: gaCookie }),
                Najezd_kmr_d38bf: this.currentKm,
                Doba_mesic_f535b: this.currentMonth,
                Mesicni_sp_19f57: this.currentPriceWithoutTax,
                Typ_osoby_17af4: typeMap[type],
                Odkaz_na_n_b3c28: window.location.href ?? 'Neznámé',
                Leasingova_1625b: this.car?.op_leas_cmp,
                be_id_dd960: this.car?.be_id,
                Vyrobce_73e48: this.car?.manufac,
                Model_34f09: this.car?.mdl,
                Vybavovy_s_e0cf2: this.car?.eqp_lev,
                Karoserie_3e000: this.car?.body,
                Prevodovka_635c6: this.car?.trans,
                Palivo_ba5e3: this.car?.fuel,
                Pohon_ca199: this.car?.drive
            },
            topic: `${this.car?.title} ${this.car?.dsc}`,
            priority: "DEFAULT",
            companyName: formData.company,
            firstName: formData.name,
            lastName: formData.surname,
            notice: formData.message ?? 'Neznámé',
            regNumber: formData.ico ?? 'Neznámé',
            contactInfo: {
                email: formData.email,
                tel1: `${formData.phoneCode}${formData.phone}`
            }
        };
    }
    changeMonth(event) {
        const element = event.target;
        this.currentMonth = Number(element.value);
        this.updatePriceValues();
    }
    changeKm(event) {
        const element = event.target;
        this.currentKm = Number(element.value);
        this.updatePriceValues();
    }
    logToSentry(error, data) {
        Sentry.withScope(scope => {
            scope.setLevel('error');
            scope.setTag('error_type', 'form_submission_error');
            if (this.car) {
                scope.setContext('Car Information', {
                    carId: this.car.be_id,
                    title: this.car.title,
                    manufacturer: this.car.manufac,
                    model: this.car.mdl
                });
            }
            // Add form data if available
            if (data) {
                scope.setContext('Form Data', data);
            }
            Sentry.captureException(error);
        });
    }
}
export default new CarDetail();
